import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useInvoicesReportList = () => {
  const [data, setData] = useState();
  const getList = async (params) => {
    // Fetch invoices report list
    const list = await apiService.getInvoicesReportList(params);
    list && setData(list); // update data state
    return list;
  };

  return {
    data,
    getList,
  };
};
